/* eslint-disable ember/no-computed-properties-in-native-classes */
import EmberObject, { computed } from '@ember/object';

import FilterConstants from '../../filter-constants';
import Noise from './noise';
import Power from './power';
import VoltageRange from './voltage-range';
import AllowedSpecific from './allowed-specific';
import RecommendedSpecific from './recommended-specific';

export default class Optimization extends EmberObject {
  optimization;
  stopbandFrequency;
  @computed('optimization', 'stopbandFrequency') get instance() {
    var optimization = this.optimization;
    var stopbandFrequency = this.stopbandFrequency;
    var result = null;
    if (optimization === FilterConstants.optimizationType.noise) {
      result = Noise.create({ stopbandFrequency: stopbandFrequency });
    } else if (optimization === FilterConstants.optimizationType.power) {
      result = Power.create({ stopbandFrequency: stopbandFrequency });
    } else if (optimization === FilterConstants.optimizationType.allowedSpecific) {
      result = AllowedSpecific.create({ stopbandFrequency: stopbandFrequency });
    } else if (optimization === FilterConstants.optimizationType.recommendedSpecific) {
      result = RecommendedSpecific.create({ stopbandFrequency: stopbandFrequency });
    } else {
      result = VoltageRange.create({ stopbandFrequency: stopbandFrequency });
    }

    return result;
  }

  @computed('instance') get name() {
    return this.instance.name;
  }

  @computed('instance') get opAmpRequirementSpecValues() {
    return this.instance.opAmpRequirementSpecValues;
  }

  // determines initial capacitor value.
  determineCapacitorValue(stageFp) {
    var instance = this.instance;
    var result = instance.determineCapacitorValue(stageFp);

    if (result < FilterConstants.Limits.CSMALL_COMP_LIMIT) {
      result = FilterConstants.Limits.CSMALL_COMP_LIMIT;
    } else if (result > FilterConstants.Limits.CBIG_COMP_LIMIT) {
      result = FilterConstants.Limits.CBIG_COMP_LIMIT;
    }

    return result;
  }

  determineStartingR3R4Value(stageFp) {
    var instance = this.instance;
    return instance.determineStartingR3R4Value(stageFp);
  }

  getOpAmpRequirementSpecValues(stopbandFrequency) {
    var instance = this.instance;
    return instance.getOpAmpRequirementSpecValues(stopbandFrequency);
  }

  optimizeStageOrder(stagesWithActualComponents, frequencyArray) {
    var instance = this.instance;
    return instance.optimizeStageOrder(stagesWithActualComponents, frequencyArray);
  }
}
